var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaf(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 51,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M26.645 23.272a.698.698 0 00-.06-.17l-.27-.52-.41.21v-.07l.35-.26L15.075.722a1.17 1.17 0 00-2.15 0l-11.18 21.74.52.26h-.19l-.39-.12-.27.53a.44.44 0 00-.06.16 13.71 13.71 0 00-1.3 5.85 14 14 0 0013.18 13.93v7.56h1.5v-7.56a14 14 0 0013.21-13.93 13.71 13.71 0 00-1.3-5.87zm-11.91 18.28v-13.35l6.66-4-.77-1.29-5.89 3.49v-11.85h-1.46v18.6l-5.41-4.35-.93 1.17 6.34 5.1v6.43a12.43 12.43 0 01-10.46-17.78.561.561 0 000-.12l.2-.38-.24-.13v-.09l.37.11 10.92-21.24 10.91 21.24.07.12.19.39v.12a12.43 12.43 0 01-10.49 17.78l-.01.03z"
  })));
}
export default SvgLeaf;